import SalesReport from "@/sales/usecases/sales-report";

export default class SalesReportPresentationModel {
  public constructor(private report: SalesReport = new SalesReport()) {}

  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  profitabilityFormatter = Intl.NumberFormat("ja-JP", {
    style: "percent"
  });

  /**
   * 売上
   */
  get sales(): string {
    return this.formatter.format(this.report.sales);
  }

  /**
   * 前年同月比
   */
  get salesComparison(): string {
    return this.formatter.format(this.salesComparisonNum);
  }

  /**
   * 売上の変化
   */
  get salesChange(): string {
    if (this.salesComparisonNum > 0) {
      return "↑";
    }
    if (this.salesComparisonNum < 0) {
      return "↓";
    }
    return "→";
  }

  /**
   * 売上の変化の色付け
   */
  get salesChangeColor(): string {
    if (this.salesComparisonNum > 0) {
      return "var(--primary)";
    }
    if (this.salesComparisonNum < 0) {
      return "var(--danger)";
    }
    return "var(--info)";
  }

  /**
   * 請求書の発行枚数
   */
  get invoices(): string {
    return `${this.report.invoices} 枚`;
  }

  /**
   * 発注額
   */
  get purchaseAmounts(): string {
    return this.formatter.format(this.report.purchaseAmounts);
  }

  /**
   * 受注総額
   */
  get total(): string {
    return this.formatter.format(this.report.total);
  }

  /**
   * 発注総額
   */
  get purchasesTotal(): string {
    return this.formatter.format(this.report.purchasesTotal);
  }

  /**
   * 発注書の発行枚数
   */
  get purchases(): string {
    return `${this.report.purchases} 枚`;
  }

  /**
   * 利益率
   */
  get profit(): string {
    return this.formatter.format(this.report.profit);
  }

  /**
   * 表示期間の利益率
   */
  get totalProfit(): string {
    return this.formatter.format(this.report.totalProfit);
  }

  /**
   * 利益率
   */
  get profitability(): string {
    return this.report.profitability.toFixed(2) + " %";
  }

  /**
   * 表示期間の利益率
   */
  get totalProfitability(): string {
    return this.report.totalProfitability.toFixed(2) + " %";
  }

  private get salesComparisonNum() {
    return this.report.sales - this.report.salesThisMonthLastYear;
  }
}
